<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="批次"><el-input v-model="query.batchNo" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="物料"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmCadIntegration:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmCadIntegration:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="code" label="检入批次" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmCadIntegration:info') || isAuth('plm:plmCadIntegration:update')" class="code-link" @click="open(scope.row)">{{ scope.row.code }}</a>
          <span v-else>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" />
      <el-table-column prop="materialName" label="物料名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="fileName" label="文件名" min-width="160" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="filePath" label="文件路径" min-width="180" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="80" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.status === '1' ? '成功' : '失败' }}</template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :title="form.id ? '修改CAD检入' : '新增CAD检入'" :visible.sync="visible" width="min(640px, calc(100vw - 24px))" :close-on-click-modal="false">
      <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="检入批次" prop="batchNo"><el-input v-model="form.batchNo" /></el-form-item>
        <el-form-item label="物料">
          <el-input v-model="form.materialCode" readonly placeholder="点击选择">
            <el-button slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="图号"><el-input v-model="form.drawingNo" /></el-form-item>
        <el-form-item label="文件名"><el-input v-model="form.fileName" /></el-form-item>
        <el-form-item label="文件路径"><el-input v-model="form.filePath" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="成功" value="1" /><el-option label="失败" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button v-if="form.id && (isAuth('plm:plmCadIntegration:delete') || isAuth('plm:plmCadIntegration:save'))" type="danger" @click="remove">删除</el-button>
        <el-button v-if="form.id ? (isAuth('plm:plmCadIntegration:update') || isAuth('plm:plmCadIntegration:save')) : isAuth('plm:plmCadIntegration:save')" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmCadIntegration',
  components: { MaterialSelector },
  data() {
    return {
      query: { batchNo: '', materialCode: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, visible: false,
      materialSelectorVisible: false, permCodes: [], form: {},
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: { batchNo: [{ required: true, message: '批次号不能为空', trigger: 'blur' }] }
    }
  },
  computed: {
    filtered() {
      return this.list.filter(row => this.has(row.code, this.query.batchNo) && this.has(row.materialCode, this.query.materialCode))
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/checkin/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    onMaterialSelect(row) {
      this.form.materialId = row.materialId
      this.form.materialCode = row.materialCode
      this.form.materialName = row.materialName
      this.materialSelectorVisible = false
    },
    open(row) {
      this.visible = true
      const blank = () => ({ id: '', batchNo: '', materialId: '', materialCode: '', drawingNo: '', fileName: '', filePath: '', status: '1', remark: '' })
      if (!row || !row.id) {
        this.form = blank()
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      request.get('/plm/checkin/info', { params: { id: row.id } }).then(res => {
        const data = res.data || {}
        this.form = {
          id: data.id || row.id,
          batchNo: data.batchNo || data.code || row.code || '',
          materialId: data.materialId || '',
          materialCode: data.materialCode || row.materialCode || '',
          drawingNo: data.drawingNo || row.drawingNo || '',
          fileName: data.fileName || row.fileName || '',
          filePath: data.filePath || row.filePath || '',
          status: data.status != null ? String(data.status) : '1',
          remark: data.remark || ''
        }
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        this.form = {
          id: row.id, batchNo: row.code || '', materialId: row.materialId || '', materialCode: row.materialCode || '',
          drawingNo: row.drawingNo || '', fileName: row.fileName || '', filePath: row.filePath || '',
          status: row.status != null ? String(row.status) : '1', remark: row.remark || ''
        }
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      })
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/plm/checkin/save', {
          id: this.form.id, batchNo: this.form.batchNo, materialId: this.form.materialId,
          drawingNo: this.form.drawingNo, fileName: this.form.fileName, filePath: this.form.filePath,
          status: this.form.status, remark: this.form.remark
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.load() }).catch(() => {})
      })
    },
    remove() {
      if (!this.form.id) return
      this.$confirm('确定删除该CAD检入记录?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/checkin/delete', { id: this.form.id }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
